import cn from "@utils/cn";
import { getLink } from "@utils/linkUtils";
import { useSession } from "next-auth/react";
import { useLocale } from "next-intl";
import { useContext } from "react";

import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "@/components/ui/Button/Button";
import Icon from "@/components/ui/Icon/Icon";
import { ModalsContext } from "@/context/ModalsContext";
import { carouselClick, ctaClickTracking } from "@/dataLayer/dataLayer";
import { CustomLink } from "@/types";

import "./CardCarouselBottomNavigation.css";

type CardCarouselBottomNavigationProps = {
  carouselId: string;
  customClass?: string;
  cta?: CustomLink;
  variant?: boolean;
  carouselType?: string;
};

export function CardCarouselBottomNavigation({ carouselId, customClass, cta, variant, carouselType }: CardCarouselBottomNavigationProps) {
  const locale = useLocale();
  const { additionalInfo } = useContext(ModalsContext);
  const { data: session } = useSession();

  return (
    <>
      <div className={cn("flex items-center justify-center md:justify-normal gap-l md:w-[80%] md:ml-[calc(100%_*_2_/_24)]", customClass)}>
        <div
          className={`cardgallery-swiper cardgallery-swiper--autogenerated swiper-pagination-carousel swiper-pagination-carousel-${carouselId} !mt-0 !top-0 !h-1`}
        />

        <div className="hidden text-right md:block md:mr-m">
          <div className="inline-flex md:w-[96px] justify-between rtl:flex-row-reverse">
            <Button
              rounded
              size={ButtonSize.MEDIUM}
              theme={ButtonTheme.WHITE}
              type="button"
              variant={ButtonVariant.PRIMARY}
              onClick={() => {
                carouselClick({
                  step_name: "Left",
                  carousel_name: `damac_${carouselType}`,
                  carousel_page: `project_entrypoint`,
                  user_logged_in: !!session,
                  // user_id: session?.user.id || "",
                  ...additionalInfo,
                });
                ctaClickTracking(`damac_${carouselType}` || "", "CardCarouselBottomNavigation", "project_entrypoint");
              }}
              customClass={`cardgallery-swiper swiper-button-prev-${carouselId} flex justify-center items-center w-[44px] h-[44px]`}
            >
              <span className="flex items-center justify-center">
                <Icon name="arrow-left" size="20" title="Prev slide" />
                <span className="sr-only">Prev Slide</span>
              </span>
            </Button>
            <Button
              rounded
              size={ButtonSize.MEDIUM}
              theme={ButtonTheme.WHITE}
              type="button"
              variant={ButtonVariant.PRIMARY}
              onClick={() => {
                carouselClick({
                  step_name: "Right",
                  carousel_name: `damac_${carouselType}`,
                  carousel_page: `project_entrypoint`,
                  user_logged_in: !!session,
                  // user_id: session?.user.id || "",
                  ...additionalInfo,
                });
                ctaClickTracking(`damac_${carouselType}` || "", "CardCarouselBottomNavigation", "project_entrypoint");
              }}
              customClass={`cardgallery-swiper swiper-button-next-${carouselId} flex justify-center items-center w-[44px] h-[44px]`}
            >
              <span className="flex items-center justify-center">
                <Icon name="arrow-right" size="20" title="Next slide" />
                <span className="sr-only">Next Slide</span>
              </span>
            </Button>
          </div>
        </div>
      </div>
      {cta && !variant && (
        <div className="flex justify-center mt-xl text-center">
          <Button size={ButtonSize.MEDIUM} theme={ButtonTheme.BLACK} type="button" variant={ButtonVariant.PRIMARY} href={getLink(cta, locale)}>
            {cta.label}
          </Button>
        </div>
      )}
    </>
  );
}
